/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

const userAgent = navigator.userAgent.toLowerCase()
export const isIOS =
  /(iphone|ipad|ipod)/i.test(userAgent) && !(window as any).MSStream

export const isIOS18 =
  /(iphone\s+os\s+18)/i.test(userAgent) && !(window as any).MSStream

export const isAndroid = /(android|adr)/i.test(userAgent)

export const isDesktop = !isIOS && !isAndroid

export const isWechat = /(micromessenger|wechat)/i.test(userAgent)

export const isMiniProgram = isWechat && /(miniprogram)/i.test(userAgent)

export const isHuawei = /huawei/i.test(userAgent)

export const isHonor = /honor/i.test(userAgent)

export const isHuaweiNote = /huaweinoh/i.test(userAgent)

export const isSMF721 = userAgent.includes('sm-f721')

export const win = {
  get wx() {
    return (window as any).wx
  },
  get WeixinJSBridge() {
    return (window as any).WeixinJSBridge
  }
}

export const query = Object.fromEntries(
  (window.location.search?.replace('?', '').split('&') || [])
    .filter(param => param.trim())
    .map(param => param.split('='))
    .map(([k, v]) => [k.toLowerCase(), v])
) as {
  version?: 'develop' | 'trial' | 'release'
  openid?: string
  unionid?: string
  channel?: string
  set?: string
  reset?: string
  skuid?: string
  tag?: string
}
